// Standalone preview comp — SubscribeCover for Maggi clip 50000.
// 1280×704 · 16fps · 56 frames (3.5s).
// Behavior: slide-in from bottom 0→0.4s, hold full opacity 0.4→2.5s,
// fade-out 2.5→3.5s. translateY stays at 0 during fade — opacity only.
import React from "react";
import { AbsoluteFill, useCurrentFrame, useVideoConfig, interpolate } from "remotion";

const clamp = { extrapolateLeft: "clamp" as const, extrapolateRight: "clamp" as const };

const SubscribeCoverSlide: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const t = frame / fps;

  // Slide-in from below the frame: y goes +220 → 0 over 0 → 0.4s.
  const y       = interpolate(t, [0, 0.4], [220, 0], clamp);
  // Fade-out: opacity 1 → 0 over 3.0 → 4.0s.
  const opacity = interpolate(t, [3.0, 4.0], [1, 0], clamp);

  return (
    <AbsoluteFill>
      <div
        style={{
          position: "absolute",
          left: 400,
          top:  570,
          width: 480,
          height: 110,
          transform: `translateY(${y}px)`,
          opacity,
          background: "#cc0000",
          borderRadius: 999,
          boxShadow: "0 6px 28px rgba(0,0,0,0.55), 0 0 0 2px rgba(255,255,255,0.08) inset",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 16,
          color: "#ffffff",
          fontFamily: "Inter, sans-serif",
          fontWeight: 900,
          fontSize: 44,
          letterSpacing: 2,
          textShadow: "0 2px 8px rgba(0,0,0,0.6)",
        }}
      >
        <span style={{ fontSize: 38, lineHeight: 1, transform: "translateY(2px)" }}>▶</span>
        SUBSCRIBE
      </div>
    </AbsoluteFill>
  );
};

export const MaggiSubCoverPreview: React.FC = () => <SubscribeCoverSlide />;

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
